"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const ActionTypes = require("../../actionTypes/auth/resetPassword");
exports.initialState = {
    view: 'default',
    password: '',
    confirmPassword: '',
    status: 'STANDBY',
    resendStatus: 'STANDBY',
    error: null,
    email: null,
    code: null,
    mode: 'reset'
};
const passwordLens = monocle.Lens.fromProp('password');
const confirmPasswordLens = monocle.Lens.fromProp('confirmPassword');
const statusLens = monocle.Lens.fromProp('status');
const resendStatusLens = monocle.Lens.fromProp('resendStatus');
const viewLens = monocle.Lens.fromProp('view');
const errorLens = monocle.Lens.fromProp('error');
const emailLens = monocle.Lens.fromProp('email');
const codeLens = monocle.Lens.fromProp('code');
const modeLens = monocle.Lens.fromProp('mode');
exports.methods = {};
exports.methods[ActionTypes.SET_RESET_PASSWORD] = (state, action) => passwordLens.set(action.payload)(state);
exports.methods[ActionTypes.SET_RESET_PASSWORD_CONFIRM_PASSWORD] = (state, action) => confirmPasswordLens.set(action.payload)(state);
// RESET PASSWORD
exports.methods[ActionTypes.RESET_PASSWORD_REQUEST] = (state) => fp.function.compose(errorLens.set(null), statusLens.set('SENDING'))(state);
exports.methods[ActionTypes.RESET_PASSWORD_VALIDATION] = (state, action) => fp.function.compose(errorLens.set(action.payload), statusLens.set('FAILED'))(state);
exports.methods[ActionTypes.RESET_PASSWORD_SUCCESS] = (state) => fp.function.compose(viewLens.set('login'), statusLens.set('SENDED'))(state);
exports.methods[ActionTypes.RESET_PASSWORD_FAILURE] = (state, action) => {
    if (action.payload &&
        action.payload.type === 'BAD_REQUEST' &&
        action.payload.error) {
        switch (action.payload.error.code) {
            case 'EXPIRED':
                return fp.function.compose(viewLens.set('expired'), errorLens.set('API_ERROR'), statusLens.set('FAILED'))(state);
        }
    }
    return fp.function.compose(errorLens.set('API_ERROR'), statusLens.set('FAILED'))(state);
};
// RESEND VERIFY MAIL
exports.methods[ActionTypes.RESEND_VERIFY_EMAIL_REQUEST] = (state) => resendStatusLens.set('SENDING')(state);
exports.methods[ActionTypes.RESEND_VERIFY_EMAIL_SUCCESS] = (state) => resendStatusLens.set('SENDED')(state);
exports.methods[ActionTypes.RESEND_VERIFY_EMAIL_FAILURE] = (state) => resendStatusLens.set('FAILED')(state);
// RESEND RESET PASSWORD MAIL
exports.methods[ActionTypes.RESEND_RESET_PASSWORD_EMAIL_REQUEST] = (state) => resendStatusLens.set('SENDING')(state);
exports.methods[ActionTypes.RESEND_RESET_PASSWORD_EMAIL_SUCCESS] = (state) => resendStatusLens.set('SENDED')(state);
exports.methods[ActionTypes.RESEND_RESET_PASSWORD_EMAIL_FAILURE] = (state) => resendStatusLens.set('FAILED')(state);
exports.methods[ActionTypes.VALIDATE_DATA] = (state, action) => {
    const currentTime = ~~(new Date().getTime() / 1000);
    const expiration = parseInt(action.payload.expiration, 10);
    if (isNaN(expiration) || currentTime > expiration) {
        return fp.function.compose(emailLens.set(typeof action.payload.email === 'string'
            ? decodeURIComponent(action.payload.email).trim()
            : null), modeLens.set(action.payload.mode), viewLens.set('expired'))(state);
    }
    return fp.function.compose(emailLens.set(decodeURIComponent(action.payload.email).trim()), modeLens.set(action.payload.mode), codeLens.set(action.payload.code), viewLens.set('form'))(state);
};
//# sourceMappingURL=resetPassword.js.map